import { render, staticRenderFns } from "./store-new-order.vue?vue&type=template&id=5de13152"
import script from "./store-new-order.vue?vue&type=script&lang=js"
export * from "./store-new-order.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports